import { call, select } from "redux-saga/effects";
import { TempIdsMap } from "../../../../api/api-slice";
import { selectComponentTempIdsMap } from "../../../../api/selectors";
import ComponentsService from "../../../../../services/ComponentsService";
import { IUpdateComponentCommand } from "@growth-machine-llc/stridist-api-client";

export default function* lockComponentWorker(payload: {
    componentId: number;
    currentState: boolean;
  }) {
  const { componentId, currentState } = payload;

  const map: TempIdsMap = yield select(selectComponentTempIdsMap);
  const checkedComponentId = map?.[componentId] || componentId;

  const command: IUpdateComponentCommand = {
    id: checkedComponentId,
    locked: !currentState,
  };

  try {
    yield call(ComponentsService.update, command);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
